const Loader = () => (
  <div className="grid-broadcast-item loader loader-container">
    <div className="spinner" />
    <span className="loadingText">Loading...</span>
  </div>
);

export default Loader;
